var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorpedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4971 7.18237V4.14037C36.4971 3.97237 36.4131 3.81537 36.2721 3.72337C36.1321 3.63037 35.9541 3.61537 35.8001 3.68037L29.8001 6.25137C29.6161 6.33037 29.4971 6.51137 29.4971 6.71137V11.1624L36.4971 7.18237ZM44.9861 12.4364C44.8931 12.2954 44.7361 12.2114 44.5691 12.2114H41.3581L37.3771 19.2114H41.9991C42.1991 19.2114 42.3801 19.0924 42.4581 18.9084L45.0291 12.9084C45.0941 12.7534 45.0781 12.5764 44.9861 12.4364ZM19.5461 38.0344L29.1541 28.5034L20.0961 19.4444L10.5661 29.0544L19.5461 38.0344ZM26.7751 15.0104L22.3951 17.5014L31.0971 26.2044L33.5881 21.8244L26.7751 15.0104ZM39.6331 8.96737C39.1561 8.48937 38.4171 8.39037 37.8311 8.72437L29.4791 13.4734L35.1261 19.1204L39.8761 10.7694C40.2101 10.1824 40.1111 9.44437 39.6331 8.96737ZM8.45409 31.1844L7.51709 32.1284C6.32109 33.3244 5.66309 34.9144 5.66309 36.6064C5.66309 38.2984 6.32209 39.8884 7.51809 41.0844C8.71409 42.2804 10.3041 42.9384 11.9961 42.9384C13.6861 42.9384 15.2761 42.2804 16.4711 41.0854L17.4171 40.1464L8.45409 31.1844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorpedo);
export default __webpack_public_path__ + "static/media/torpedo.56df3b502ec5e224ecab7bb66f320cbb.svg";
export { ForwardRef as ReactComponent };